import { Spin } from "antd";
import { LoadingSpinContainer } from "./styled";
import { useContext } from "react";
import { ContextProviderWrapper } from "../../Context";

const LoadingSpin = ({ text }: any) => {
  const { theme }: any = useContext(ContextProviderWrapper);
  return (
    <LoadingSpinContainer className={theme}>
      <Spin size="large" />
      <p>{text ? text : "Please wait a sec..."}</p>
    </LoadingSpinContainer>
  );
};

export default LoadingSpin;
